import { render, staticRenderFns } from "./number.vue?vue&type=template&id=7f284cde&scoped=true"
import script from "./number.vue?vue&type=script&lang=js"
export * from "./number.vue?vue&type=script&lang=js"
import style0 from "./number.vue?vue&type=style&index=0&id=7f284cde&prod&lang=css"
import style1 from "./number.vue?vue&type=style&index=1&id=7f284cde&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f284cde",
  null
  
)

export default component.exports